import React, { useState } from 'react';
import { DatePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { useTranslation } from 'react-i18next';
import { Box, Icon, IconButton } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { Typography } from '../../../../ui-kit';
import { ResetCallback, UpdateFromCallback, UpdateToCallback } from './types';

interface DateFromToPickerProps {
    updateToCallback?: UpdateFromCallback;
    updateFromCallback?: UpdateToCallback;
    resetCallback?: ResetCallback;
    startDate?: MaterialUiPickersDate;
    endDate?: MaterialUiPickersDate;
    hideReset?: boolean;
}

const DateFromToPicker = ({
    updateFromCallback,
    updateToCallback,
    resetCallback,
    startDate,
    endDate,
    hideReset,
}: DateFromToPickerProps) => {
    const [dateFrom, setDateFrom] = useState<MaterialUiPickersDate>(startDate || null);
    const [dateTo, setDateTo] = useState<MaterialUiPickersDate>(endDate || null);
    const [dateFromFocused, setDateFromFocused] = useState<boolean>(false);
    const [dateToFocused, setDateToFocused] = useState<boolean>(false);
    const { t } = useTranslation();

    const handleDateFromChange = (date: MaterialUiPickersDate) => {
        if(date){
            const dayEnd = date.startOf('day');
            setDateFrom(dayEnd);
            if(updateFromCallback){
                updateFromCallback(dayEnd.toJSDate(), dateTo);
            }
        }
        if(dateTo === null){
            focusTo();
        }
    };

    const handleDateToChange = (date: MaterialUiPickersDate) => {
        if(date){
            const dayEnd = date.endOf('day');
            setDateTo(dayEnd);
            if(updateToCallback){
                updateToCallback(dayEnd.toJSDate(), dateFrom);
            }
        }
        if(dateFrom === null){
            focusFrom();
        }
    };

    const focusFrom = () => {
        setDateFromFocused(true);
    };
    const focusTo = () => {
        setDateToFocused(true);
    };
    const closeFrom = () => {
        setDateFromFocused(false);
    };
    const closeTo = () => {
        setDateToFocused(false);
    };

    const resetDates = () => {
        setDateFrom(null);
        setDateTo(null);

        if(resetCallback){
            resetCallback();
        }
    };

    return (
        <Box display='flex' alignItems='center'>
            <DatePicker
                onClose={closeFrom}
                onOpen={focusFrom}
                open={dateFromFocused}
                focused={dateFromFocused}
                variant='inline'
                inputVariant='outlined'
                size='small'
                value={dateFrom}
                onChange={handleDateFromChange}
                format="dd/MM/yyyy"
                maxDate={dateTo || undefined}
                label={t('Start')}
                autoOk
            />
            <Box mx={1}>
                <Typography>-</Typography>
            </Box>
            <DatePicker
                onClose={closeTo}
                onOpen={focusTo}
                open={dateToFocused}
                focused={dateToFocused}
                variant='inline'
                inputVariant='outlined'
                size='small'
                value={dateTo}
                onChange={handleDateToChange}
                format="dd/MM/yyyy"
                minDate={dateFrom || undefined}
                label={t('End')}
                autoOk
            />
            {hideReset
                ? null
                : (
                    <Box ml={1}>
                        <IconButton onClick={resetDates}>
                            <Icon>
                                <ClearIcon />
                            </Icon>
                        </IconButton>
                    </Box>
                )}
        </Box>
    );
};

export default DateFromToPicker;
